import { useInstallPrompt } from '../lib/use-install-prompt';
import { Button } from './ui/button';

// Minimal banner that opt-in / opt-outs the native install prompt. Hidden
// when the browser hasn't fired `beforeinstallprompt`, when the user
// dismissed it within the last 7 days, or when the app is already
// running as a standalone PWA.
export function InstallPrompt(): React.JSX.Element | null {
  const state = useInstallPrompt();
  if (state.status !== 'available') return null;
  return (
    <aside
      aria-labelledby="install-prompt-title"
      className="fixed bottom-3 left-1/2 z-40 w-[min(420px,calc(100%-1.5rem))] -translate-x-1/2 rounded-2xl bg-white p-4 shadow-lg ring-1 ring-black/5"
    >
      <h2 id="install-prompt-title" className="text-sm font-semibold text-ink">
        Install Food Diary
      </h2>
      <p className="mt-1 text-xs text-ink/70">
        Add it to your home screen for offline access and a one-tap launch.
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <Button
          type="button"
          variant="ghost"
          onClick={() => {
            state.dismiss();
          }}
        >
          Later
        </Button>
        <Button
          type="button"
          onClick={() => {
            void state.promptInstall();
          }}
        >
          Install
        </Button>
      </div>
    </aside>
  );
}
